import { defineMessages } from 'react-intl';

export default defineMessages({
    specifyOtherQuestion: {
        id: 'exitPoll.specifyOtherQuestion',
        defaultMessage: 'Can you specify?'
    },
    specifyOtherBack: {
        id: 'exitPoll.specifyOtherBack',
        defaultMessage: 'Back'
    },
    specifyOtherAnswerPlaceholder: {
        id: 'exitPoll.specifyOtherAnswerPlaceholder',
        defaultMessage: 'Sure, no problem...'
    },
    submitExitPoll: {
        id: 'exitPoll.submit',
        defaultMessage: 'Submit'
    }
});
